import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ShoppingCardService } from '../../services/shopping-card.service';
import { SettingsService } from '../../services/settings.service';

@Component({
  selector: 'app-shopping-card-success',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ButtonModule,
    ToastModule
  ],
  providers: [MessageService],
  templateUrl: './shopping-card-success.component.html',
  styleUrl: './shopping-card-success.component.css'
})
export class ShoppingCardSuccessComponent implements OnInit {
  orderId = signal<string>('');
  platformId = signal<string>('');
  platformName = signal<string>('');
  remainingBalance = signal<number | null>(null);
  amountDeducted = signal<number | null>(null);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private shoppingCardService: ShoppingCardService,
    private settingsService: SettingsService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    // Get query parameters
    this.route.queryParams.subscribe(params => {
      const orderId = params['orderId'];
      const platformId = params['platformId'];
      const platformName = params['platformName'];
      const remainingBalance = params['remainingBalance'];
      const amountDeducted = params['amountDeducted'];

      if (orderId) {
        this.orderId.set(orderId);
      }

      if (platformId) {
        this.platformId.set(platformId);
      }

      if (platformName) {
        try {
          this.platformName.set(decodeURIComponent(platformName));
        } catch (e) {
          this.platformName.set(platformName);
        }
      }

      if (remainingBalance) {
        this.remainingBalance.set(parseFloat(remainingBalance));
      }

      if (amountDeducted) {
        this.amountDeducted.set(parseFloat(amountDeducted));
      }

      // Show success message
      this.messageService.add({
        severity: 'success',
        summary: 'Payment Successful',
        detail: 'Your order has been placed successfully using your shopping card!',
        life: 5000
      });

      // Clear shopping card cache to refresh balance
      if (platformId) {
        const environment = this.settingsService.getEnvironment();
        this.shoppingCardService.clearCache(platformId, environment);
      }
    });
  }

  continueShopping(): void {
    const platformId = this.platformId();
    const platformName = this.platformName();
    
    if (platformId && platformName) {
      const encodedName = encodeURIComponent(platformName);
      this.router.navigate(['/store', platformId, encodedName], { replaceUrl: true });
    } else {
      this.router.navigate(['/'], { replaceUrl: true });
    }
  }
}
